import {Semaine} from "../domain/Semaine";
import {Mois} from "../domain/Mois";

export const allMois = [
  new Mois('202601', 'Janvier', '2026'),
  new Mois('202602', 'Février', '2026'),
  new Mois('202603', 'Mars', '2026'),
  new Mois('202604', 'Avril', '2026'),
  new Mois('202605', 'Mai', '2026'),
  new Mois('202606', 'Juin', '2026'),
  new Mois('202607', 'Juillet', '2026'),
  new Mois('202608', 'Août', '2026'),
  new Mois('202609', 'Septembre', '2026'),
  new Mois('202610', 'Octobre', '2026'),
  new Mois('202611', 'Novembre', '2026'),
  new Mois('202612', 'Décembre', '2026'),
];
export const allSemaines = [
  new Semaine('S2601', 1, 1.10, 1.00, '202601', '2026'),
  new Semaine('S2602', 2, 0.75, 0.65, '202601', '2026'),
  new Semaine('S2603', 3, 0.75, 0.65, '202601', '2026'),
  new Semaine('S2604', 4, 0.70, 0.65, '202601', '2026'),
  new Semaine('S2605', 5, 0.90, 1.00, '202601', '2026'),
  new Semaine('S2606', 6, 1.10, 1.20, '202602', '2026'),
  new Semaine('S2607', 7, 1.15, 1.20, '202602', '2026'),
  new Semaine('S2608', 8, 1.05, 1.20, '202602', '2026'),
  new Semaine('S2609', 9, 0.95, 1.15, '202602', '2026'),
  new Semaine('S2610', 10, 0.85, 1.10, '202603', '2026'),
  new Semaine('S2611', 11, 0.80, 1.00, '202603', '2026'),
  new Semaine('S2612', 12, 0.95, 1.00, '202603', '2026'),
  new Semaine('S2613', 13, 0.80, 0.80, '202603', '2026'),
  new Semaine('S2614', 14, 1.15, 1.20, '202604', '2026'),
  new Semaine('S2615', 15, 1.05, 1.20, '202604', '2026'),
  new Semaine('S2616', 16, 1.00, 1.20, '202604', '2026'),
  new Semaine('S2617', 17, 1.00, 1.20, '202604', '2026'),
  new Semaine('S2618', 18, 0.95, 1.20, '202605', '2026'),
  new Semaine('S2619', 19, 0.80, 0.90, '202605', '2026'),
  new Semaine('S2620', 20, 0.75, 0.90, '202605', '2026'),
  new Semaine('S2621', 21, 0.85, 1.10, '202605', '2026'),
  new Semaine('S2622', 22, 0.80, 1.00, '202605', '2026'),
  new Semaine('S2623', 23, 0.70, 1.00, '202606', '2026'),
  new Semaine('S2624', 24, 0.80, 1.10, '202606', '2026'),
  new Semaine('S2625', 25, 0.90, 1.00, '202606', '2026'),
  new Semaine('S2626', 26, 1.10, 1.70, '202606', '2026'),
  new Semaine('S2627', 27, 1.05, 1.50, '202607', '2026'),
  new Semaine('S2628', 28, 0.95, 1.10, '202607', '2026'),
  new Semaine('S2629', 29, 1.10, 1.10, '202607', '2026'),
  new Semaine('S2630', 30, 1.00, 1.10, '202607', '2026'),
  new Semaine('S2631', 31, 1.10, 1.10, '202608', '2026'),
  new Semaine('S2632', 32, 0.95, 0.90, '202608', '2026'),
  new Semaine('S2633', 33, 0.80, 0.90, '202608', '2026'),
  new Semaine('S2634', 34, 0.75, 0.65, '202608', '2026'),
  new Semaine('S2635', 35, 0.65, 0.70, '202608', '2026'),
  new Semaine('S2636', 36, 0.70, 0.90, '202609', '2026'),
  new Semaine('S2637', 37, 0.70, 0.90, '202609', '2026'),
  new Semaine('S2638', 38, 0.70, 0.90, '202609', '2026'),
  new Semaine('S2639', 39, 0.75, 1.00, '202609', '2026'),
  new Semaine('S2640', 40, 0.90, 1.00, '202610', '2026'),
  new Semaine('S2641', 41, 0.85, 1.00, '202610', '2026'),
  new Semaine('S2642', 42, 1.05, 1.20, '202610', '2026'),
  new Semaine('S2643', 43, 1.25, 1.20, '202610', '2026'),
  new Semaine('S2644', 44, 1.10, 1.20, '202610', '2026'),
  new Semaine('S2645', 45, 1.00, 1.10, '202611', '2026'),
  new Semaine('S2646', 46, 1.10, 1.15, '202611', '2026'),
  new Semaine('S2647', 47, 0.90, 1.15, '202611', '2026'),
  new Semaine('S2648', 48, 1.00, 1.15, '202611', '2026'),
  new Semaine('S2649', 49, 0.90, 1.50, '202612', '2026'),
  new Semaine('S2650', 50, 0.95, 1.60, '202612', '2026'),
  new Semaine('S2651', 51, 1.50, 1.65, '202612', '2026'),
  new Semaine('S2652', 52, 1.65, 1.65, '202612', '2026'),
];
